// extracted by mini-css-extract-plugin
export default {"optionMargin":"CheckerModalFormDark__optionMargin___YqJYe"};